// extracted by mini-css-extract-plugin
export default {"borderText":"FAQs_borderText__a2Jk1","primaryText":"FAQs_primaryText__UZklw","secondaryText":"FAQs_secondaryText__FlNjJ","card":"FAQs_card__y9VX2","image":"FAQs_image__UJyB4"};